import { ConfigService } from 'src/app/shared/services/config/config.service';
import { environment } from 'src/environments/environment';

export function initPropeller(configService: ConfigService): void {
  const node = getPropellerNode(configService);
  document.getElementsByTagName('head')[0].appendChild(node);
}

export function getPropellerNode(configService: ConfigService): HTMLLinkElement {
  const node = document.createElement('link');

  const propUrl = environment.propeller_dev_url
    ? environment.propeller_dev_url
    : `${environment.propeller_url}/${environment.propeller_version}`;

  node.href = removeDoubleSlashes(`${propUrl}/css/${configService.getProperty<string>('STYLE_CODE')}-bundled.css`);
  node.rel = 'stylesheet';
  node.type = 'text/css';
  node.id = 'themeStyleSheet';
  return node;
}

export function removeDoubleSlashes(url: string): string {
  return url.replace(/([^:]\/)\/+/g, '$1');
}
